﻿const browserDetection = require('./components/browserDetection/browserDetection.js');
const heroCarousels = require('./components/heroCarousels/heroCarousels.js');
const mainNav = require('./components/mainNav/mainNav.js');
const criticalTakeoverAlert = require('./components/criticalTakeoverAlert/criticalTakeoverAlert.js');
const alertBanner = require('./components/alertBanner/alertBanner.js');
const olbLogin = require('./components/olbLogin/olbLogin.js');
const ratesTables = require('./components/ratesTables/ratesTables.js');
const accessibilityManager = require('./components/accessibilityManager/accessibilityManager.js');
const featuredServiceBlocks = require('./components/featuredServiceBlocks/featuredServiceBlocks.js');

function _registerEventHandlers() {

    browserDetection.addBrowserClass('html');
    mainNav.initialize();
    heroCarousels.initialize();
    criticalTakeoverAlert.initialize();
    alertBanner.initialize('.alert-bar-wrapper', '#alert-bar-button');
    olbLogin.initialize();
    ratesTables.initialize();
    accessibilityManager.initialize();

    var isMobileDevice = browserDetection.isMobileDevice();
    if (!isMobileDevice) {
        featuredServiceBlocks.initialize();
    }
    
}
_registerEventHandlers();

// Start document ready
$(function () {

    $('#main').prepend($('<div/>', {
        id: 'body-dark'
    }))
    const $modal = $("div.slider-form-container");
    $(".btn-toggle-login-modal").on('click', function () {
        $modal.toggleClass("show-modal");
        $('body #body-dark').toggleClass('active');
        $('body').toggleClass('no-scroll')
    });
    $(window).on('click', function (event) {
        if ($(event.target).is($modal)) {
            $modal.removeClass("show-modal");
            $('body #body-dark').removeClass('active');
            $('body').removeClass('no-scroll');
        }
        $('.close').on('click', function () {
            $modal.removeClass("show-modal");
            $('body #body-dark').removeClass('active');
            $('body').removeClass('no-scroll');
        });
    });

    $('.fouc').removeClass('fouc');

    // SHOW GLOBAL SEARCH INPUT
    $('.searchbox > i').on('click', function () {
        $(this).hide();
        $('.searchbox > form').addClass('active');
    });

    $('.rel-img').each(function () {
        var bgImg = $(this).css('background-image');
        var matchingItem = $(this).parent('li').attr('data-pair');

        bgImg = bgImg.replace('url(', '').replace(')', '');
        $('.feature-item[data-pair = ' + matchingItem + ']').prepend("<img src=" + bgImg + ">");
    });

    // UNORDERED LIST FORMATTING FOR 'CHECKED LIST'
    $('li > span.checked').closest('ul').addClass("check-list");
    $('li > span.chevron').closest('ul').addClass("link-list");

    // GRID TRICKERY
    var flowedGridRow = $('#gridContent > article .flow');
    var flowingColumns = flowedGridRow.slice(1).children('.columns');
    flowingColumns.appendTo('#gridContent > article .flow');
    flowedGridRow.slice(1).remove();

    // End document ready
});



var windowResizeEvent = function (object, type, callback) {
    if (object == null || typeof (object) == 'undefined') return;
    if (object.addEventListener) {
        object.addEventListener(type, callback, false);
    } else if (object.attachEvent) {
        object.attachEvent("on" + type, callback);
    } else {
        object["on" + type] = callback;
    }
};
windowResizeEvent(window, "resize", function (event) {
    if (window.innerWidth >= 940) {
        document.body.setAttribute("data-nav-drawer", "closed");
    }
    if (window.innerWidth < 920) {
        if ($('#branch-location-list').has('active-button')) {
            //
        }
        else {
            $('.map-filters-list').removeClass('ng-hide').addClass('ng-show');
            $('.overlay').removeClass('ng-hide').addClass('ng-show');
            $('#lstView').removeClass('ng-hide').addClass('ng-show');
            $('#map-view').toggleClass('active-button');
            $('#branch-location-list').addClass('active-button');
        }
        $('.map-filters-list').removeClass('ng-hide').addClass('ng-show');
        $('.overlay').removeClass('ng-hide').addClass('ng-show');
        $('#lstView').removeClass('ng-hide').addClass('ng-show');
        $('#map-view').removeClass('active-button');
        $('#branch-location-list').addClass('active-button');

    }
});

function equalheight(container) {

    var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = new Array(),
        $el,
        topPosition = 0;
    $(container).each(function () {

        $el = $(this);
        $($el).height('auto')
        topPostion = $el.position().top;

        if (currentRowStart != topPostion) {
            for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
            }
            rowDivs.length = 0; // empty the array
            currentRowStart = topPostion;
            currentTallest = $el.height();
            rowDivs.push($el);
        } else {
            rowDivs.push($el);
            currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
        }
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            rowDivs[currentDiv].height(currentTallest);
        }
    });
}

$(window).on('load', function () {
    equalheight('.feature.item-box');
    if (window.innerWidth >= 800) {
        equalheight('.content.flow .columns');
    } else {
        $('.content.flow .columns').removeAttr('style');
    }
});


$(window).on('resize', function () {
    equalheight('.feature.item-box');
    if (window.innerWidth >= 800) {
        equalheight('.content.flow .columns');
    } else {
        $('.content.flow .columns').removeAttr('style');
    }
});

//$(window).on("load", function() {
//   //GA Tracking on calculators
//	var currentPage = document.location.href;
//	var calc = "ga('send', 'event', 'Calculator',  'Calculate Btn Clicked',  'On:  " + currentPage + "');";
//	var report = "ga('send', 'event', 'Calculator',  'View Report Btn Clicked',  'On: " + currentPage + "');";
//	var email = "ga('send', 'event', 'Calculator',  'Email Btn Clicked',  'On: " + currentPage + "');";
//	var save = "ga('send', 'event', 'Calculator',  'Create Save Data Entry Btn Clicked',  'On: " + currentPage + "');";
//	var print = "ga('send', 'event', 'Calculator',  'Print Report Btn Clicked',  'On: " + currentPage + "');";

//	$('#KJECalculate').attr('onclick', calc);
//	$('#KJEViewReport').attr('onclick', report);
//	//$('#KJEEmail').attr('onclick', email);
//	//$('#KJESave').attr('onclick', save);
//	$('.KJECommandButton[value="Print"]').attr('onclick', print);

//	//Track Form Submits
//	var getForm = $('.contour input[type="submit"]');
//	$(getForm).attr("onclick","ga('send', 'event', 'Form Submitted',  '"+ window.location.pathname +"',  'submitted');");

//});


//check for cookie on page load
$(window).on('load', function () {
    //find azstcu_username cooki
    var nameEQ = 'oneaz_username=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) var foundCookie = c.substring(nameEQ.length, c.length);
    }
    if (foundCookie) {
        $('input[name="userid"]').val(foundCookie);
        $('input[name="remember-me"]').attr('checked', 'checked');
    }

});
